module.exports = require('./helpers/bundle-url').getBundleURL('2ws0Z') + "logo.7718c6df.svg";